import { useFeatureValue } from '@shared/core/featureFlags';
import { getTransferPartnerConfig } from './transferPartnerConfigs';
import type { TransferPartnerConfig } from './transferPartnerConfigs';

export type ActiveTransferPartners = Readonly<{
  activeTransferConfig: TransferPartnerConfig | null;
  activeRepeatConfig: TransferPartnerConfig | null;
}>;

export const useActiveTransferPartners = (): ActiveTransferPartners => {
  const { value: activePartner } = useFeatureValue('activeCashFundPartner');
  const { value: transferPartner } = useFeatureValue('enableCashFundPartnerTransferToBank');
  const { value: repeatTransferPartner } = useFeatureValue('enableCashFundPartnerTransferToBankRepeat');

  return {
    activeTransferConfig: activePartner && activePartner === transferPartner ? getTransferPartnerConfig(activePartner) : null,
    activeRepeatConfig: activePartner && activePartner === repeatTransferPartner ? getTransferPartnerConfig(activePartner) : null,
  };
};
